import { render, staticRenderFns } from "./ListFormApp.vue?vue&type=template&id=010cd728&"
import script from "./ListFormApp.vue?vue&type=script&lang=js&"
export * from "./ListFormApp.vue?vue&type=script&lang=js&"
import style0 from "./ListFormApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports